import { ConfigType, getConfigApi } from "@/api/config";
import { ServiceTypes } from "@/api/customservice";
import { create } from "zustand";

interface State extends ConfigType {
    isCollapse: boolean;
    isHasDesktop: boolean | undefined;
    service: ServiceTypes[];
}

interface Action {
    setCollapse: (value: boolean) => void;
    setHasDesktop: (value: boolean) => void;
    setupConfig: () => void;
    setService: (value: ServiceTypes[]) => void;
}

const initialState: State = {
    // 是否展开侧边栏
    isCollapse: false,
    // 是否含有快应用
    isHasDesktop: undefined,
    show_free_game: 2,
    show_again_game: 2,
    identity_verify: {
        deposit: 2,
        /**
         * 注册实名，
         */
        register: 2,
        /**
         * 提现实名
         */
        withdraw: 2,
    },
    service: [],
};

/**
 * @description 系统配置
 */
export const useSystemStore = create<State & Action>()((set, get) => {
    return {
        ...initialState,
        setCollapse: (value) => set((state) => ({ ...state, isCollapse: value })),
        setHasDesktop: (value) => set((state) => ({ ...state, isHasDesktop: value })),
        setService(value) {
            set((state) => ({ ...state, service: value }));
        },
        setupConfig: () => {
            try {
                getConfigApi().then((config) => {
                    set((state) => ({ ...state, ...config }));
                });
            } catch (e) {}
        },
        reset: () => set(initialState),
    };
});
